module.exports = __webpack_public_path__ + "static/img/header.e7881e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/header.png
// module id = C/5X
// module chunks = 167